import { render, staticRenderFns } from "./RentProductType.vue?vue&type=template&id=4112d04a&scoped=true&"
import script from "./RentProductType.vue?vue&type=script&lang=ts&"
export * from "./RentProductType.vue?vue&type=script&lang=ts&"
import style0 from "./RentProductType.vue?vue&type=style&index=0&id=4112d04a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4112d04a",
  null
  
)

export default component.exports